import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-servicing/constants/apiPaths';
import {
    SvcGstDtlGetDepositBalanceCertificateRequest,
    SvcGstDtlGetDepositBalanceCertificateResponse,
    SvcGstDtlGetFinancialTransactionConfirmationRequest,
    SvcGstDtlGetFinancialTransactionConfirmationResponse,
    SvcGstDtlGetFindIssuedCertificatesRequest,
    SvcGstDtlGetFindIssuedCertificatesResponse,
    SvcGstDtlGetLiabilityBalanceCertificateRequest,
    SvcGstDtlGetLiabilityBalanceCertificateResponse,
} from 'scbk-servicing/types/api';

/**
 *  스피드조회 > 예금잔액 증명서 Hook *
 */
export const useSvcGstDtlGetDepositBalanceCertificate = (
    mutationOptions?: UseRestPostMutationOptions<
        SvcGstDtlGetDepositBalanceCertificateRequest,
        SvcGstDtlGetDepositBalanceCertificateResponse
    >,
) => {
    return useRestPost<
        SvcGstDtlGetDepositBalanceCertificateRequest,
        SvcGstDtlGetDepositBalanceCertificateResponse
    >(
        {
            endpoint: APIS.services.guest.findDetail.getDepositBalanceCertificate,
        },
        mutationOptions,
    );
};

/**
 *  스피드조회 > 금융거래 부채증명서 발급내역 Hook *
 */
export const useSvcGstDtlGetFindIssuedCertificates = (
    mutationOptions?: UseRestPostMutationOptions<
        SvcGstDtlGetFindIssuedCertificatesRequest,
        SvcGstDtlGetFindIssuedCertificatesResponse
    >,
) => {
    return useRestPost<
        SvcGstDtlGetFindIssuedCertificatesRequest,
        SvcGstDtlGetFindIssuedCertificatesResponse
    >(
        {
            endpoint: APIS.services.guest.findDetail.getFindIssuedCertificates,
        },
        mutationOptions,
    );
};

/**
 *  스피드조회 > 금융거래 확인서 Hook *
 */
export const useSvcGstDtlGetFinancialTransactionConfirmation = (
    mutationOptions?: UseRestPostMutationOptions<
        SvcGstDtlGetFinancialTransactionConfirmationRequest,
        SvcGstDtlGetFinancialTransactionConfirmationResponse
    >,
) => {
    return useRestPost<
        SvcGstDtlGetFinancialTransactionConfirmationRequest,
        SvcGstDtlGetFinancialTransactionConfirmationResponse
    >(
        {
            endpoint: APIS.services.guest.findDetail.getFinancialTransactionConfirmation,
        },
        mutationOptions,
    );
};

/**
 *  스피드조회 > 부채잔액 증명서 Hook *
 */
export const useSvcGstDtlGetLiabilityBalanceCertificate = (
    mutationOptions?: UseRestPostMutationOptions<
        SvcGstDtlGetLiabilityBalanceCertificateRequest,
        SvcGstDtlGetLiabilityBalanceCertificateResponse
    >,
) => {
    return useRestPost<
        SvcGstDtlGetLiabilityBalanceCertificateRequest,
        SvcGstDtlGetLiabilityBalanceCertificateResponse
    >(
        {
            endpoint: APIS.services.guest.findDetail.getLiabilityBalanceCertificate,
        },
        mutationOptions,
    );
};
